"use client";

import {initializeApp} from "firebase/app";
import {getApps, getApp} from "firebase/app";
import {getAuth} from "firebase/auth";
import {GoogleAuthProvider} from "firebase/auth";
import {getFirestore} from "firebase/firestore";
import {getDatabase} from "firebase/database";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
    apiKey: "AIzaSyDWzEIKhU8M7sTTCmb5OgpTix8kCVqgGQk",
    authDomain: "unitrend-378fb.firebaseapp.com",
    projectId: "unitrend-378fb",
    storageBucket: "unitrend-378fb.appspot.com",
    messagingSenderId: "507763682210",
    appId: "1:507763682210:web:b49f37e8199d3e4090e0fb",
    measurementId: "G-0YY5MVE5X5",
    databaseURL: "https://unitrend-378fb-default-rtdb.asia-southeast1.firebasedatabase.app"
};

const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

const auth = getAuth(app);
const dbFire = getFirestore(app)
const database = getDatabase(app);

const provider = new GoogleAuthProvider();

export {auth, provider, dbFire, app, database}